import {
  getMeasurementTypeKeyByName,
  allMeasurementStatistics
} from '@/services/device-measurements'
import type { StdTelemetry, TelemetrySensor } from '@/types/devices'

export interface TelemetryReading {
  name: string
  timestamp: string
  value: number | boolean | string | null
}

const getSensorReadings = (sensor: TelemetrySensor): Record<string, TelemetryReading> | null => {
  if (sensor?.measurements) {
    let readings: Record<string, TelemetryReading> = {}
    const measurements = sensor.measurements
    for (const [measurementKey] of Object.entries(measurements)) {
      const measurement = measurements[measurementKey]
      if (measurement) {
        readings = {
          ...readings,
          [measurementKey]: {
            name: measurementKey,
            timestamp: measurement.timestamp,
            value: measurement.value
          }
        }
      }
    }
    return readings
  }
  return null
}

export const getTelemetryReadingsObject = (
  telemetry: StdTelemetry
): Record<string, TelemetryReading> | null => {
  if (telemetry?.sensors) {
    const sensors = telemetry.sensors
    let readings: Record<string, TelemetryReading> = {}
    for (const [sensorKey] of Object.entries(sensors)) {
      const sensor = sensors[sensorKey]
      readings = {
        ...readings,
        ...getSensorReadings(sensor)
      }
    }

    return readings
  }

  return null
}

export const getAllTelemetryStatisticsReadingsObject = (
  telemetry: StdTelemetry
): Record<string, TelemetryReading> | null => {
  const readings = getTelemetryReadingsObject(telemetry)
  const measurementStatistics: Record<string, TelemetryReading> = {}

  if (readings) {
    for (const [measurementName] of Object.entries(readings)) {
      const measurementKey = getMeasurementTypeKeyByName(measurementName)
      if (allMeasurementStatistics.indexOf(measurementKey) !== -1) {
        measurementStatistics[measurementName] = readings[measurementName]
      }
    }
  }

  return Object.entries(measurementStatistics).length ? measurementStatistics : null
}
